import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { useAppRunningContext } from 'features/EmbeddedRh24/useAppRunningContext'
import appLogo from '_icons/logo/QF_logoHrz_tag.png'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '526px',
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(3),
    },
    subtitle: {
      paddingLeft: '3px',
      fontVariant: 'all-small-caps',
      letterSpacing: theme.spacing(0.25),
      whiteSpace: 'nowrap',
      fontSize: '1em',
    },
    strong: {
      fontWeight: 600,
    },
    img: {
      width: '100%',
      height: '100%',
    },
  })
)

const ProductName = () => {
  const cn = useStyles()

  const { withinIframe } = useAppRunningContext()

  if (withinIframe) {
    return null
  }

  return (
    <div className={cn.root}>
      <img src={appLogo} alt="Quotation Factory" className={cn.img} />

      {/* <Typography variant="h3" className={cn.strong}>
        Rhodium<sup>24</sup>
      </Typography>
      <Divider orientation="horizontal" />
      <LocalizedTypography
        className={cn.subtitle}
        variant="subtitle1"
        translationKey={'common:product-subtitle'}
      /> */}
    </div>
  )
}

export { ProductName }
